import React, { Fragment } from "react"
import { useTranslation } from "react-i18next"

import { LazyImage } from "components"
import { thousandSeparator } from "utils"
import { languageSuffixMap } from "constant"
import classes from "./KioskFoodImage.module.scss"

const KioskFoodImage = (props) => {
  const { food, selectedOption } = props

  const i18n = useTranslation()[1]

  if (!selectedOption) return null

  const percentag =
    ((selectedOption.price - selectedOption.salePrice) / selectedOption.price) * 100 | 0

  const field = `name${languageSuffixMap[i18n.language]}`

  return (
    <Fragment>
      <h1 className={classes["title"]}>
        {food[field]}
      </h1>

      {selectedOption.price > selectedOption.salePrice
        ?
        <div className={classes["row"]}>
          <span className={classes["sale-price"]}>
            {thousandSeparator(selectedOption.salePrice)}
          </span>
          <span className={classes["price"]}>
            {thousandSeparator(selectedOption.price)}
          </span>
          <span className={classes["tag"]}>
            {percentag}%
          </span>
        </div>
        :
        <span className={classes["sale-price"]}>
          {thousandSeparator(selectedOption.salePrice)}
        </span>
      }

      <div className={classes["image-container"]}>
        <LazyImage
          src={food.imageCover}
          imageWidth={720}
          quality={80}
          className={classes["image"]}
        />
      </div>
    </Fragment>
  )
}

export default KioskFoodImage